import React from 'react'

// Project Images
import { defaultImg } from '../img'

const Project = (props) => {
  return (
    <div className="no-padding portfolio_container clearfix">
      {props.projects.map((project, index) => {
        return (
          <div key={index} className="col-md-4 col-sm-6">
            <span id="lang02" className="portfolio_item">
              <img src={defaultImg} alt={project.projectName || 'Project image'} className="img-responsive" />
              <div className="portfolio_item_hover">
                <div className="portfolio-border clearfix">
                  <div className="item_info">
                    <span>{project.projectName}</span> <em>{project.extraInfo}</em>
                    <span>
                      {project.projectLink !== '' ? (
                        <em className="project-link">
                          <a href={project.projectLink} target="_blank" rel="noopener noreferrer">
                            View Demo
                          </a>
                        </em>
                      ) : (
                        ''
                      )}
                      {project.projectSourceCode !== '' ? (
                        <em className="project-link">
                          <a href={project.projectSourceCode} target="_blank" rel="noopener noreferrer">
                            View Source Code
                          </a>
                        </em>
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default Project
